import * as React from "react";
import { useTranslation } from "react-i18next";
import { Spinner } from "components/common";
import ExpandedSectionCount from "components/common/EntityDataTable/ExpandedSectionCount";
import { useForwarderInputMetricsFor } from "../ForwarderInputMetricsContext";
import { METRIC_COLUMN_IDS } from "../metricColumns";
const SECTION_NAME = METRIC_COLUMN_IDS.associatedStreams;
const AssociatedStreamsCell = ({ input }) => {
  const { t } = useTranslation("enterprise_forwarder");
  const { metrics, isInitialLoading, isError } = useForwarderInputMetricsFor(input.input_id, input.forwarder_node_id);
  if (isInitialLoading && !metrics) {
    return /* @__PURE__ */ React.createElement(Spinner, { size: "xs" });
  }
  if (isError || !(metrics == null ? void 0 : metrics.messages_per_stream)) {
    return /* @__PURE__ */ React.createElement("span", { "aria-label": t("associated_streams_cell.no_streams_aria", { title: input.title }) }, "\u2014");
  }
  const streamCount = Object.keys(metrics.messages_per_stream).length;
  return /* @__PURE__ */ React.createElement(
    ExpandedSectionCount,
    {
      entityId: input.id,
      section: SECTION_NAME,
      count: streamCount,
      label: t("associated_streams_cell.section_label", { title: input.title })
    }
  );
};
export default AssociatedStreamsCell;
